export const images = [
    "/assets/portfolioContent/0coperta.jpg",
    "/assets/portfolioContent/1info.jpg",
    "/assets/portfolioContent/2tableofcontents.jpg",
    "/assets/portfolioContent/3blank.jpg",

    "/assets/portfolioContent/4_REcreate.jpg",
    "/assets/portfolioContent/5_REcreate.jpg",
    "/assets/portfolioContent/6_REcreate.jpg",
    "/assets/portfolioContent/7_REcreate.jpg",

    "/assets/portfolioContent/8_REcreate.jpg",
    "/assets/portfolioContent/9_00.jpg",
    "/assets/portfolioContent/10_Rasnov.jpg",
    "/assets/portfolioContent/11_Rasnov.jpg",

    "/assets/portfolioContent/12_Rasnov.jpg",
    "/assets/portfolioContent/13_Rasnov.jpg",
    "/assets/portfolioContent/14_Rasnov.jpg",
    "/assets/portfolioContent/15_Rasnov.jpg",

    "/assets/portfolioContent/16_Rasnov.jpg",
    "/assets/portfolioContent/17_00.jpg",
    "/assets/portfolioContent/18_Delta Dunarii.jpg",
    "/assets/portfolioContent/19_Delta Dunarii.jpg",

    "/assets/portfolioContent/20_Delta Dunarii.jpg",
    "/assets/portfolioContent/21_Delta Dunarii.jpg",
    "/assets/portfolioContent/22_Delta Dunarii.jpg",
    "/assets/portfolioContent/23_00.jpg",

    "/assets/portfolioContent/24_IBIS.jpg",
    "/assets/portfolioContent/25_IBIS.jpg",
    "/assets/portfolioContent/26_IBIS.jpg",
    "/assets/portfolioContent/27_IBIS.jpg",

    "/assets/portfolioContent/28_IBIS.jpg",
    "/assets/portfolioContent/29_IBIS.jpg",
    "/assets/portfolioContent/30_IBIS.jpg",
    "/assets/portfolioContent/31_00.jpg",

    "/assets/portfolioContent/32_Caliman.jpg",
    "/assets/portfolioContent/33_Caliman.jpg",
    "/assets/portfolioContent/34_Caliman.jpg",
    "/assets/portfolioContent/35_Caliman.jpg",

    "/assets/portfolioContent/36_Caliman.jpg",
    "/assets/portfolioContent/37_00.jpg",
    "/assets/portfolioContent/38_Forest House.jpg",
    "/assets/portfolioContent/39_Forest House.jpg",

    "/assets/portfolioContent/40_Forest House.jpg",
    "/assets/portfolioContent/41_Forest House.jpg",
    "/assets/portfolioContent/42_Forest House.jpg",
    "/assets/portfolioContent/43_Forest House.jpg",

    "/assets/portfolioContent/44_Forest House.jpg",
    "/assets/portfolioContent/45_00.jpg",
    "/assets/portfolioContent/46_D HOUSE.jpg",
    "/assets/portfolioContent/47_D HOUSE.jpg",

    "/assets/portfolioContent/48_D HOUSE.jpg",
    "/assets/portfolioContent/49_D HOUSE.jpg",
    "/assets/portfolioContent/50_D HOUSE.jpg",
    "/assets/portfolioContent/51_00.jpg",

    "/assets/portfolioContent/52_NORTH FACE.jpg",
    "/assets/portfolioContent/53_NORTH FACE.jpg",
    "/assets/portfolioContent/54_NORTH FACE.jpg",
    "/assets/portfolioContent/55_00.jpg",

    "/assets/portfolioContent/56_PRIVATE SCHOOL.jpg",
    "/assets/portfolioContent/57_PRIVATE SCHOOL.jpg",
    "/assets/portfolioContent/58_PRIVATE SCHOOL.jpg",
    "/assets/portfolioContent/59_00.jpg",

    "/assets/portfolioContent/60_TINY HOUSE.jpg",
    "/assets/portfolioContent/61_TINY HOUSE.jpg",
    "/assets/portfolioContent/62_TINY HOUSE.jpg",
    "/assets/portfolioContent/63_TINY HOUSE.jpg",

    "/assets/portfolioContent/64_TINY HOUSE.jpg",
    "/assets/portfolioContent/65_TINY HOUSE.jpg",
    "/assets/portfolioContent/66_TINY HOUSE.jpg",
    "/assets/portfolioContent/67_00.jpg",

    "/assets/portfolioContent/68_DIPLOMA.jpg",
    "/assets/portfolioContent/69_DIPLOMA.jpg",
    "/assets/portfolioContent/70_DIPLOMA.jpg",
    "/assets/portfolioContent/71_DIPLOMA.jpg",

    "/assets/portfolioContent/72_DIPLOMA.jpg",
    "/assets/portfolioContent/73_DIPLOMA.jpg",
    "/assets/portfolioContent/74_DIPLOMA.jpg",
    "/assets/portfolioContent/75_DIPLOMA.jpg",

    "/assets/portfolioContent/76_DIPLOMA.jpg",
    "/assets/portfolioContent/77_DIPLOMA.jpg",
    "/assets/portfolioContent/78_DIPLOMA.jpg",
    "/assets/portfolioContent/79_00.jpg",

    "/assets/portfolioContent/80_STRUCTURI SPECIALE.jpg",
    "/assets/portfolioContent/81_STRUCTURI SPECIALE.jpg",
    "/assets/portfolioContent/82_STRUCTURI SPECIALE.jpg",
    "/assets/portfolioContent/83_STRUCTURI SPECIALE.jpg",

    "/assets/portfolioContent/84_STRUCTURI SPECIALE.jpg",
    "/assets/portfolioContent/85_00.jpg",
    "/assets/portfolioContent/86_FACULTATE.jpg",
    "/assets/portfolioContent/87_FACULTATE.jpg",

    "/assets/portfolioContent/88_FACULTATE.jpg",
    "/assets/portfolioContent/89_FACULTATE.jpg",
    "/assets/portfolioContent/90_FACULTATE.jpg",
    "/assets/portfolioContent/91_FACULTATE.jpg",

    "/assets/portfolioContent/92_FACULTATE.jpg",
    "/assets/portfolioContent/93_FACULTATE.jpg",
    "/assets/portfolioContent/94_FACULTATE.jpg",
    "/assets/portfolioContent/95_FACULTATE.jpg",

    "/assets/portfolioContent/96_FACULTATE.jpg",
    "/assets/portfolioContent/97_FACULTATE.jpg",
    "/assets/portfolioContent/98_FACULTATE.jpg",
    "/assets/portfolioContent/99_00.jpg",
];
